import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}>
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function Brandings() {

    const brandingSteps = [
        { number: "01", title: "Brand Audit & Research", description: "We analyze your current brand, competitors, and market trends to build a strategy.", icon: "📤" },
        { number: "02", title: "Strategy & Concept Development", description: "Our team develops brand concepts, messaging, and visual identity frameworks.", icon: "⚡" },
        { number: "03", title: "Design & Visual Identity", description: "We design logos, color schemes, typography, and brand assets for consistent branding.", icon: "✓" },
        { number: "04", title: "Implementation & Support", description: "We implement your brand identity across all materials and provide ongoing guidance and updates.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Branding Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Professional branding services in Los Angeles, CA. Build a strong brand identity with expert design and strategy." />
                <meta name="keywords" content="branding services, brand identity design, business branding services, corporate branding Los Angeles, branding agency near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Brandings</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Brandings</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/logo1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Build a Brand That Stands Out</span>
                                <h3 className="case-study-title">Expert Branding Services in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we provide comprehensive branding services in Los Angeles, California, helping businesses create a consistent and professional brand image. Effective branding builds credibility, strengthens customer trust, and ensures your business stands out in a competitive market.
                                </p>
                                <p className="case-study-description">
                                    Our team works closely with you to develop a cohesive visual and strategic brand identity, including logos, color palettes, typography, marketing materials, and digital presence. Whether you are launching a new business or revamping an existing brand, our branding services deliver a polished and professional look that resonates with your target audience. If you’re searching for branding services near you in Los Angeles, Grand Indigo Embroidery is your trusted partner for high-quality brand solutions.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Consistency Across Every Touchpoint</span>
                                <h3 className="case-study-title">Tailored Branding Solutions for Businesses</h3>
                                <p className="case-study-description">
                                    We offer custom branding solutions designed to reflect your business values and connect with your audience. Our services include visual identity development, brand strategy, marketing collateral, and digital branding integration. We ensure every element of your brand communicates professionalism and consistency across all touchpoints. You can also order branding services online to receive a full brand identity package conveniently and efficiently.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/logo2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={brandingSteps} />

            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is included in your branding services?"
                                    answer="We provide visual identity, brand strategy, marketing materials, and digital branding solutions."
                                />

                                <FaqItem
                                    question="Do you offer branding services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides professional branding services in Los Angeles, California for local and online clients."
                                />

                                <FaqItem
                                    question="Can you create a complete brand identity for a new business?"
                                    answer="Absolutely. We design comprehensive brand identities that include logos, style guides, and marketing assets."
                                />

                                <FaqItem
                                    question="How long does a branding project take?"
                                    answer="Most branding projects take 3–6 weeks depending on complexity and deliverables."
                                />

                                <FaqItem
                                    question="Can I order branding services online?"
                                    answer="Yes, you can order branding services online and receive a complete, professionally designed brand package."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
